<template>
  <div id="intro-1" class="intro-box">
    <div class="intro-box__wrapper">
      <div class="intro-box__header">
        <h3>Welcome to Visceral's <br>Vendor Consignment</h3>
      </div>

      <div class="intro-box__content">
        <p>With this app you will be able to track all orders for all your vendors and easily
          calculate how much you owe them.</p>

        <p>There are a few things we will need to get started. Please accept the terms before
          proceeding.</p>
      </div>

      <div class="intro-box__wrapper--fixed">
        <div class="form-field text-left">
          <div class="grid-x">
            <div class="cell shrink">
              <div :class="['checkbox-choice', termsAccepted ? 'active' : '']"
                   @click="agreeToTerms">
                <input id="agree-terms" type="checkbox" name="agree-terms"
                       :checked="termsAccepted">
              </div>
            </div>

            <div class="cell auto">
              <label class="checkbox-choice__label" for="agree-terms">I agree to the Visceral Apps
                <router-link to="/terms-of-service">Terms of Service</router-link> and
                <router-link to="/privacy-policy">Privacy Policy</router-link>.
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="intro-box__footer">
      <button :class="['button--wide', !termsAccepted ? 'disabled': '']" @click="changeStep()">
        Get Started
      </button>
    </div>

    <div class="intro-box__pagination">
      <span class="active"></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
  </div>
</template>

<script>
import client from '@/mixins/client'

export default {
  mixins: [client],
  data: function () {
    return {
      termsAccepted: false
    }
  },
  methods: {
    agreeToTerms () {
      this.termsAccepted = !this.termsAccepted
    },
    changeStep (next = true) {
      if (this.termsAccepted) {
        this.request('put', '/shopify/shops/' + this.$store.state.shop.id + '/retrieve-update/', {
          agree_to_terms: this.termsAccepted
        }).then(response => {
          this.$emit('changeStep', next)
        })
      }
    }
  }
}
</script>

<style lang="scss">
  @import '../../../styles/mixins';
  @import '../../../styles/variables';
</style>



// WEBPACK FOOTER //
// src/apps/vendorconsignment/tutorials/step1.vue